import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../../services/authService';

// requiredRoles : liste de rôles acceptés (l'utilisateur doit en avoir au moins un).
// Par défaut, seul ROLE_ADMIN est accepté (comportement historique).
const AdminRoute = ({ children, requiredRoles = ['ROLE_ADMIN'] }) => {
  const isAuth = isAuthenticated();

  if (!isAuth) {
    return <Navigate to="/login" />;
  }

  // Vérifier si l'utilisateur a l'un des rôles requis
  const userInfo = localStorage.getItem('userInfo');
  if (userInfo) {
    const user = JSON.parse(userInfo);
    const roles = user.roles || [];

    const hasAccess = roles.includes('ROLE_ADMIN') || requiredRoles.some((role) => roles.includes(role));

    if (!hasAccess) {
      // Rediriger vers le dashboard utilisateur si accès refusé
      console.warn('Access denied: User does not have the required role');
      return <Navigate to="/dashboard" />;
    }
  } else {
    return <Navigate to="/login" />;
  }

  return children;
};

export default AdminRoute;
